<template>
  <div>
    <transition name="crossfade">
      <router-view :key="`${$route.params.id}`"></router-view>
    </transition>
    <div v-if="intro" class="ks-overlay ks-projects" ref="scrollContainer" :style="{'overflow-y': tmHitareaActive || dropFilter  ? 'hidden' : 'auto' }" v-on:scroll.passive="$root.measure($event, $refs.scrollTarget)">
      <div class="ks-overlay-hitarea" v-on:mouseover="$root.hitareaActive = true" v-on:mouseout="$root.hitareaActive = false"  v-on:click="$router.push({name:'home'})"/>
      <div class="ks-overlay-container" ref="scrollTarget">
          <Closetag v-if="!$route.params.id && !dropFilter"/>
          <div class="ks-close-wrapper" v-if="dropFilter">
              <a class="ks-close" :class="`ks-close-${$route.params.route || $route.name}`" v-on:click.prevent="dropFilter = false">
                  <span/>
                  <span/>
              </a>
          </div>
          <div class="ks-overlay-container-head">
              <h1>
                Projekte
              </h1>
          </div>
          <div class="ks-overlay-container-fixbox" ref="fixbox">
            <div class="ks-roundbox">
              <div class="ks-overlay-container-small" v-if="intro.TabularText && intro.TabularText.length > 0">
                <div class="ks-sticky-list" v-for="(r, rk) in intro.TabularText" v-bind:key="`sticky-${rk}`">
                  <div class="ks-sticky-list-float" v-html="r[0].nl2br()"/>
                  <div class="ks-sticky-list-content" v-html="r[1].nl2br()"/>
                </div>
              </div>
              <div class="ks-overlay-container-small" v-html="intro.Text"/>
              <div class="ks-roundbox ks-roundbox-nopadding" v-if="intro.Bilder && intro.Bilder.length > 0">
                <div class="ks-red-button-wrapper"  v-for="(l, lk) in intro.Bilder" v-bind:key="`linkrow-${lk}`">
                  <a class="ks-red-button ks-red-button-autoheight" :href="l.Original" target="_blank"><span>{{l.Captions[0]}}</span></a>
                </div>
              </div>
            </div>
          </div>
          <div @click.prevent="dropFilter = false" class="ks-overlay-container-stickysubhead ks-projects-controller"  :class="{'ks-projects-controller-timemachine': this.current.timemachine}" ref="controller">
            <div class="ks-overlay-container-stickysubhead-wrapper">
              <div class="ks-bullet-list" :class="{'ks-bullet-list-active': dropFilter}">
                <a class="ks-bullet-list-point" v-on:click.stop="openFilter"/>
                <a class="ks-round-button ks-round-button-nozoom" :class="{'ks-round-button-active': dropFilter}" v-on:click.stop="openFilter">
                  <span class="desktop-inline">Projekte Filtern</span>
                  <span class="tablet-inline">Filter</span>
                </a>
              </div>
              <div class="ks-toggle ks-toggle-mode">
                <VueToggles
                  @click="current.timemachine = !current.timemachine"
                  :value="current.timemachine"
                  :class="{'vue-toggles-active': current.timemachine}"
                  :height="40"
                  :width="140"
                />
              </div>
              <div class="ks-slider">
                <vue-slider
                v-model="current.id"
                ref="slider"
                @change="sliderChange"
                :lazy="current.timemachine?true:false"
                :data="slider.ids"
                :marks="false"
                :dotSize="dotSize"
                :contained="true">
                  <template v-slot:tooltip="{ value }">
                    <div class="vue-slider-dot-tooltip vue-slider-dot-tooltip-top">
                      <div class="vue-slider-dot-tooltip-inner vue-slider-dot-tooltip-inner-top">
                        <span class="vue-slider-dot-tooltip-text">{{ slider.labels[value] }}</span>
                      </div>
                    </div>
                  </template>
                </vue-slider>
              </div>
            </div>
            <transition name="crossfade">
              <div class="ks-projects-filters" v-if="dropFilter">
                <div class="ks-projects-filters-wrapper">
                  <div class="ks-bullet-list ks-bullet-list-inline" v-if="status.length > 1" :class="{'ks-bullet-list-active': current.selectedStatus}">
                    <a class="ks-bullet-list-point" @click.stop="setStatus()"/>
                    <a class="ks-round-button ks-round-button-nozoom" :key="s.id" v-for="s in status" :class="{'ks-round-button-inactive': s.count == 0, 'ks-round-button-active': current.selectedStatus && current.selectedStatus.id == s.id}" @click.stop="setStatus(s)">
                      <span>{{s.value}}</span>
                    </a>
                  </div>

                  <div class="ks-bullet-list ks-bullet-list-inline" v-if="initiator.length > 1" :class="{'ks-bullet-list-active': current.selectedInitiator}">
                    <a class="ks-bullet-list-point" @click.stop="setInitiator()"/>
                    <a class="ks-round-button ks-round-button-nozoom" :key="s.id" v-for="s in initiator" :class="{'ks-round-button-inactive': s.count == 0, 'ks-round-button-active': current.selectedInitiator && current.selectedInitiator.id == s.id}" @click.stop="setInitiator(s)">
                      <span>{{s.value}}</span>
                    </a>
                  </div>

                  <div class="ks-bullet-list ks-bullet-list-inline" v-if="categories.length > 1" :class="{'ks-bullet-list-active': current.selectedFilter}">
                    <a class="ks-bullet-list-point" @click.stop="setFilter()"/>
                    <a class="ks-round-button ks-round-button-nozoom" :key="s.id" v-for="s in categories" :class="{'ks-round-button-inactive': s.count == 0, 'ks-round-button-active': current.selectedFilter && current.selectedFilter.id == s.id}" @click.stop="setFilter(s)">
                      <span>{{s.value}}</span>
                    </a>
                  </div>
                </div>
              </div>
            </transition>
          </div>
          <transition name="crossfade">
            <div class="ks-projects-blur" v-if="dropFilter" @click="dropFilter = false"/>
          </transition>
          <div class="ks-projects-hider"/>
          <transition name="crossfade" mode="out-in">
            <div
              class="ks-projects-timemachine-wrapper"
              v-if="current.timemachine && projects.length > 0"
              v-bind:key="'time'"
            >
              <a class="ks-projects-timemachine-nav ks-projects-timemachine-nav-back" v-on:click="tmBack()"></a>
              <!--<a class="ks-projects-timemachine-nav ks-projects-timemachine-nav-forward" v-on:click="tmForward()"></a>-->
              <div class="ks-projects-timemachine" v-on:mouseover="tmHitareaActive = $root.overlayScrollPercentage == 100" v-on:mouseout="tmHitareaActive = false">
                  <template v-for="bgslide in [0,1,2]">
                    <transition :key="`bgslide-${bgslide}`" :name="`timemachine-${current.direction}-${bgslide}`">
                      <div
                        class="ks-projects-timemachine-bgslot ks-projects-timemachine-bgslot-inactive"
                        :class="`ks-projects-timemachine-bgslot-${bgslide}`"
                        v-bind:key="`bgslideid-${current.lastIndex}-${bgslide}-${timeslice._id}`"
                        v-if="current.lastIndex > bgslide"
                      >
                      </div>
                    </transition>
                  </template>
                  <transition :name="`timemachine-${current.direction}`">
                    <div
                      class="ks-projects-timemachine-slot ks-projects-timemachine-slot-active"
                      v-bind:key="timeslice._id"
                      v-on:wheel.prevent="wheel($event)"
                      v-touch:swipe="swipe"
                    >
                      <router-link :to="{name:'projekt', params: {route: $route.params.route, id:timeslice._id, stub:timeslice._name}}">
                        <div class="ks-projects-timemachine-slot-upper">
                          <img v-if="timeslice.Bilder" :src="timeslice.Bilder[0].Resized[2]"/>
                        </div>
                        <div class="ks-projects-timemachine-slot-lower">
                          <h2 v-html="timeslice.Titel"/>
                          <p class="ks-projects-timemachine-slot-lower-bottom-left">
                            <span class="ks-transparent-button">{{timeslice.Laufnummer}}</span>
                          </p>
                          <p class="ks-projects-timemachine-slot-lower-bottom-right">
                            <span class="ks-transparent-button">{{timeslice.Kategorie[0]._name}}</span>
                          </p>
                        </div>
                      </router-link>
                    </div>
                  </transition>
              </div>
            </div>
            <div
              class="ks-projects-list-wrapper"
              v-if="!current.timemachine && projects.length > 0"
              v-bind:key="'list'"
            >
              <div class="ks-projects-list">
                <div
                class="ks-projects-list-card"
                :class="{'ks-projects-list-card-44': t.s_44}"
                :ref="`list-element-${t._id}`"
                v-bind:key="t._id"
                :data-id="t._id"
                :data-reference="tk"
                v-for="(t, tk) in filteredsliceReverse"
                v-observe-visibility="{
                  callback: visibilityChanged,
                  intersection: {
                    threshold: 0.25
                  }
                }"
                >
                  <router-link :to="{name:'projekt', params: {route: $route.params.route, id:t._id, stub:t._name}}">
                    <div class="ks-projects-list-card-wrapper">
                      <div class="ks-projects-list-card-upper">
                        <img v-if="t.Bilder" :data-src="t.Bilder[0].Resized[1]"/>
                      </div>
                      <div class="ks-projects-list-card-lower">
                        <h2 v-html="t.Titel"/>
                        <p class="ks-projects-list-card-lower-bottom-left">
                          <span class="ks-transparent-button">{{t.Laufnummer}}</span>
                        </p>
                        <p class="ks-projects-list-card-lower-bottom-right">
                          <span class="ks-transparent-button">{{t.Kategorie[0]._name}}</span>
                        </p>
                      </div>
                    </div>
                  </router-link>
                </div>
              </div>
            </div>
          </transition>
      </div>
    </div>
  </div>
</template>

<script>
/* eslint-disable */

import VueSlider    from 'vue-slider-component'
import vSelect      from 'vue-select'
import VueToggles   from 'vue-toggles';
import Closetag     from '../components/Closetag.vue'

export default {
  name: 'Projects',
  components: {
    VueSlider,
    vSelect,
    VueToggles,
    Closetag
  },  
  data () {
    return {
      intro: false,
      initializedOnce: false,
      dropFilter: false,
      projects: [],
      debounce: false,
      tmHitareaActive: false,
      menudata: this.$painterdata.find((e) => {return e.route === 'projekte';}),
      current: {
        id: false,
        timemachine: false,
        selectedFilter: null,
        selectedInitiator: null,
        selectedStatus: null,
        direction: ''
      },
      categories:[],
      status: [],
      initiator: [],
      scrolling: false,
      cancelScroll: false,
      filteredslice: [],
      filteredsliceReverse: [],
      slider: {
        ids: [],
        labels: {}
      }
    }
  },
  computed: {
    dotSize: function() {
      return window.innerWidth < 600 ? [80, 36] : [120, 48];
    },
    timeslice: function() {
      console.log('timeslice')      
      if (this.projects.length == 0)  return [];
      if (this.timemachine === false) return this.filteredslice;
      let _to = false;

      try {
        let _current;
        this.filteredslice.forEach((e, ek) => {
          if (e._id == this.current.id) {
            _current = e;
            _to = ek;
          }
        })

        
        if (_to > this.current.lastIndex) {
          this.current.direction = 'forward'
        }
        else if (_to < this.current.lastIndex) {
          this.current.direction = 'back'
        }
        else {
          this.current.direction = ''
        }
        this.current.lastIndex = _to;
        return _current;
      }
      catch(e) {
        console.warn(e)
        return {};
      }
    }
  },  
  mounted() {
    if (this.$root.preloaded) {
      this.init(this.$root.preloaded);
    }
    else {
      this.$http('projekte').then((d) => {
        this.$root.preloaded = d;
        this.init(this.$root.preloaded);
      });
    }
    
  },
  beforeRouteLeave (to, from, next) {
    this.$root.scrollOffset = false;
    this.$root.$emit('overlay:close', true);
    this.$root.applyMeta()
    next();
  },
  watch:{
    $route (to, from){
        if(to.name === from.name) {
          this.init();
        }
    },
    'current.selectedFilter': function(a) {
      this.createFilterSlice(a);
    },
    'current.selectedStatus': function(a) {
      this.createFilterSlice(a);
    },
    'current.selectedInitiator': function(a) {
      this.createFilterSlice(a);
    }
  }, 
  methods: {
    openFilter() {
      this.dropFilter = !this.dropFilter
    },
    swipe(e) {
      if (e == 'right') {
        this.tmBack()
      }
      if (e == 'left') {
        this.tmForward()
      }
    },
    wheel(e) {
      if (!this.wheelTimeout && this.tmHitareaActive) {
        if (e.deltaY < 0) {
          this.tmBack()
        }
        else {
          this.tmForward()
        }
        this.wheelTimeout = setTimeout(()=>{
          this.wheelTimeout = false;
        },500)
      }
      e.preventDefault();
      return false;
    },
    setStatus(s) {
      s = s || null
      this.current.selectedStatus = s == null || (this.current.selectedStatus && this.current.selectedStatus.id == s.id) ? null : s;
      if (this.current.selectedStatus && this.current.selectedStatus.count == 0) {
        this.current.selectedFilter = this.current.selectedInitiator = null;
      }
    },
    setFilter(s) {
      s = s || null
      this.current.selectedFilter = s == null || (this.current.selectedFilter && this.current.selectedFilter.id == s.id) ? null : s;

      if (this.current.selectedFilter && this.current.selectedFilter.count == 0) {
        this.current.selectedInitiator = this.current.selectedStatus = null;
      }
    },
    setInitiator(s) {
      s = s || null
      this.current.selectedInitiator = s == null || (this.current.selectedInitiator && this.current.selectedInitiator.id == s.id) ? null : s;
      if (this.current.selectedInitiator && this.current.selectedInitiator.count == 0) {
        this.current.selectedFilter = this.current.selectedStatus = null;
      }
    },
    createSliderValues() {
      this.slider = {
        ids: [],
        labels: {}
      };
      this.filteredslice.forEach(s => {
        this.slider.ids.push(s._id);
        this.slider.labels[s._id] = s.Year
      })
    },
    
    createFilterSlice(id) {
      id = id || false;
      if (this.projects.length == 0) return false;
      
      if (id && id.id) {
        window.history.replaceState(
          {},
          null,
          `/${this.$route.params.route}/${id.id}`
        )
      }

      let _slice = [];

      this.projects.forEach((p) => {
        if (
          (this.current.selectedFilter === null || p.Kategorie.filter((e) => {return e && e._id === this.current.selectedFilter.id}).length > 0) &&
          (this.current.selectedStatus === null || p.Status.filter((e) => {return e && e._id === this.current.selectedStatus.id}).length > 0) &&
          (this.current.selectedInitiator === null || p.Initiator.filter((e) => {return e && e._id === this.current.selectedInitiator.id}).length > 0)
        ) {
          _slice.push(p)
        }
      });
      // Reset current id if current id is not in slice
      if (_slice.filter((e) => {return e._id === this.current.id}).length == 0) {
        console.log('reset')
        this.current.id = _slice.length > 0 ? _slice[_slice.length - 1]._id : false
      }
      this.updateFilters(_slice);
  
      // update route - not doing this right now because of nested routes
      //let params = this.$route.params
      //params['mode'] = this.current.timemachine ? 'time' : 'list'
      //params['filter'] = this.current.selectedFilter && this.current.selectedFilter.id ? this.current.selectedFilter.id : null
      //this.$router.push({ name: this.$route.name, params: params }).catch((e)=>{console.warn(e)});
      this.filteredslice = _slice;
      this.filteredsliceReverse = _slice.slice(0).reverse();
      this.createSliderValues();
    },
    updateFilters(_slice) {

      let _categories = {};
      let _status = {};
      let _initiator = {}

      _slice.forEach((_project) => {
        _project.Kategorie.forEach(_cat => {
          if (_cat && _cat._id) {
            if (_categories[_cat._id] && _categories[_cat._id].count)
              _categories[_cat._id].count++;
            else {
              _categories[_cat._id] = {
                  "count"     : 1,
                  "value"     : _cat._name,
                  "id"        : _cat._id
              };
            }
          }
        })
        _project.Status.forEach(_stat => {
          if (_stat && _stat._id) {
            if (_status[_stat._id] && _status[_stat._id].count)
              _status[_stat._id].count++;
            else {
              _status[_stat._id] = {
                  "count"     : 1,
                  "value"     : _stat._name,
                  "id"        : _stat._id
              };
            }
          }
        })  
        _project.Initiator.forEach(_init => {
          if (_init && _init._id) {
            if (_initiator[_init._id] && _initiator[_init._id].count)
              _initiator[_init._id].count++;
            else {
              _initiator[_init._id] = {
                  "count"     : 1,
                  "value"     : _init._name,
                  "id"        : _init._id
              };
            }
          }
        })              
      })
      


      this.categories.forEach(_c => {
        _c.count = 0;
        for (let c in _categories) if (_categories.hasOwnProperty(c)) {
          if (_c.id == _categories[c].id) _c.count = _categories[c].count
        }
      })

      this.status.forEach(_s => {
        _s.count = 0;
        for (let s in _status) if (_status.hasOwnProperty(s)) {
          if (_s.id == _status[s].id) _s.count = _status[s].count
        }
      });

      this.initiator.forEach(_i => {
        _i.count = 0;
        for (let i in _initiator) if (_initiator.hasOwnProperty(i)) {
          if (_i.id == _initiator[i].id) _i.count = _initiator[i].count
        }
      });


    },
    init(d) {
      this.intro = d.data.intro[0]
      this.categories = d.data.categories;
      this.status     = d.data.status;
      this.initiator  = d.data.initiator;
      this.projects = d.data.data;
      if (!this.$route.params.id) {
        this.$root.applyMeta(
            `Kulturstiftung Thurgau ⚡️ Projekte`,
            'Kulturstiftung Thurgau Projekte Archiv',
            'Das Projektarchiv der Kulturstiftung Thurgau'
        )
      }
      if (this.$route.params.filter) {
        let _e;
        _e = this.categories.filter((e) => {return e && (e.id == this.$route.params.filter)})
        if (_e.length > 0) {
          this.current.selectedFilter = _e[0];
        }
        _e = this.status.filter((e) => {return e && (e.id == this.$route.params.filter)})
        if (_e.length > 0) {
          this.current.selectedStatus = _e[0];
        }
        _e = this.initiator.filter((e) => {return e && (e.id == this.$route.params.filter)})
        if (_e.length > 0) {
          this.current.selectedInitiator = _e[0];
        }
      }
      this.createFilterSlice();
      this.current.lastIndex = this.projects.length - 1;
      this.current.id = this.projects[this.current.lastIndex]._id
      this.$nextTick(()=>{
        if (this.initializedOnce === false) {
          var options = {
              container: this.$refs.scrollContainer,
              easing: [0.34, 1.56, 0.64, 1],
              lazy: false,
              offset: document.documentElement.clientHeight * -.5,
              force: true,
              cancelable: true,
              x: false,
              y: true,
              onDone: () => {
                this.$root.overlayOpen   = true;
                this.initializedOnce     = true;
              }
          }
          this.$scrollTo(this.$refs.scrollTarget, 350, options)
        }
      })
    },
    tmBack() {
        this.filteredslice.forEach((e, ek) => {
          if (e._id == this.current.id) {
            if (ek > 0) {
              this.current.id = this.filteredslice[ek - 1]._id
              return;
            }
          }
        })
    },
    tmForward() {
        let _newId = this.current.id      
        this.filteredslice.forEach((e, ek) => {
          if (e._id == this.current.id) {
            if (this.filteredslice[ek + 1]) {
              _newId = this.filteredslice[ek + 1]._id
            }
          }
        })
        this.current.id = _newId;
    },    
    sliderChange (value, index) {
      //console.log(this.$refs.controller.clientHeight, value, `list-element-${value}`, this.$refs)
      //this.current.id = value;

      
      if (!this.current.timemachine && this.$refs[`list-element-${value}`]) {
        /*if (this.cancelScroll) {
          clearTimeout(this.cancelScroll);
          this.cancelScroll = false;
        }
        var options = {
          container: this.$refs.scrollContainer,
          offset: -this.$refs.controller.clientHeight,
          lazy: true,
          cancelable: true,
          x: false,
          y: true,
          onCancel: () => {
            this.scrolling = false;
          },
          onDone: () => {
            this.scrolling = false;
          }
        }
        this.scrolling = true;
        this.cancelScroll = setTimeout(()=>{
          this.$scrollTo(this.$refs[`list-element-${value}`][0], 350, options)
        }, 100);
        */
        this.$refs[`list-element-${value}`][0].scrollIntoView({behavior: "smooth"});

      }
    },
    visibilityChanged (isVisible, entry) {
      try {
        let _i = entry.target.querySelector('img');
          if (isVisible)
            _i.src = _i.dataset.src;
      } catch (err) {
        console.warn('element not accessible in filteredslice')
      }
      if (this.debounce) {
        clearTimeout(this.debounce);
      }
      this.debounce = setTimeout(()=>{
        if (!this.scrolling) {
          if (isVisible) {
            this.current.id = 1 * entry.target.dataset.id
            //console.log(this.current.id)
          }
        }
      }, 150)
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss">

  @import '../_main';

  .ks-projects {
    .ks-overlay-container-fixbox,
    .ks-overlay-container-head,
    .ks-overlay-container-stickyhead,
    .ks-overlay-container-small {
      color: $ks-pink;
    }
    .ks-overlay-container-head,
    .ks-overlay-container-stickyhead,
    .ks-overlay-container-fixbox {
      background: white;
    }
    &-list-card-lower {
      color: $ks-pink;
    }


    &-blur {
      position: fixed;
      left: 0px;
      top: 0px;
      width: 100%;
      height: 100%;
      backdrop-filter: blur(1rem);
      z-index: 30;
    }
    &-hider {
      position: sticky;
      left: 0px;
      top: 0px;
      width: 100%;
      height: $nav-height;
      margin-top: -$nav-height;
      @include sm() {
        height: $nav-height * $mobile_scaling_factor;
        margin-top: -$nav-height * $mobile_scaling_factor;
      }
      background: #FFF;
      z-index: 21;
    }
    &-filters {
      @include vh(100);
      top: 0px;
      overflow: hidden;
      overflow-y: auto;
      padding-top: $nav-height;
      @include sm() {
        padding-top: $nav-height / 2;
      }      
      width: 100%;
      left: 0%;
      position: absolute;
      padding-left: var(--pd1);
      padding-right: var(--pd1);
      box-sizing: border-box;
      z-index: -1;
      &-wrapper {
        margin: auto;
        max-width: $wide-container;
      }

      .ks-bullet-list {
        margin-bottom: 0rem;
        .ks-bullet-list-point {
          background: $ks-pink;
          border-color: $ks-pink;
        }
        &-active {
          .ks-bullet-list-point {
            background: white;
          }
        }
      }
      .ks-round-button {
        background:  white;
        margin-bottom: var(--pd1);
        border-color: $ks-pink;
        span {
          color: $ks-pink;
        }
        &-active {
          span {
            color: white;
          }
          background: $ks-pink;
        }
        &-inactive {
          span {
            color: $ks-light-pink;
            opacity: 1;
          }
          border-color: $ks-light-pink;
        }
      }
    }    
    &-timemachine {
        $padding: 5rem;
        z-index: 0;
        max-width:  $wide-container;
        height: 100%;
        position: relative;
        margin: auto;
        perspective: 600px;
        overflow: visible;
        &-wrapper {
          background: #FFF;
          z-index: 29;
          //@include vhmin(100, #{$sticky-height});
          @include vh(100);
          overflow: hidden;
          position: relative;
          padding: $padding 1rem;
          padding-top: $nav-height + $padding;
          margin-top: -$nav-height;
          box-sizing: border-box;
          @include sm() {
            //@include vhmin(100, #{$sticky-height * $mobile_scaling_factor});
            padding: $padding/2 1rem 1rem 1rem;
            padding-top: $nav-height * $mobile_scaling_factor;
            margin-top: -$nav-height * $mobile_scaling_factor;
          }          
        }
        &-nav {
          position: absolute;
          left: 0rem;
          z-index: 20;
          height: 2rem;
          cursor: pointer;
          height: 5rem;
          width: 100%;
          top: $nav-height;
          @include sm() {
            top: $nav-height * $mobile_scaling_factor;
          }          
        }
        &-bgslot,
        &-slot {
          position: absolute;
          right: 0em;
          width: 100%;
          height: 100%;
          background: $ks-grey;
          border-radius: 1.5rem;
          transition: all 1s;
          box-sizing: border-box;
          overflow: hidden;
          &-upper {
            height: 66%;
            overflow: hidden;
            position: relative;
            img {
              width: 100%;
              height: 100%;
              position: absolute;
              left: 0px;
              top: 0px;
              object-fit: cover;
              filter: grayscale(100%);
            }
            &:after {
              content: "";
              position: absolute;
              left: 0px;
              top: 0px;
              width: 100%;
              height: 100%;
              background:  $ks-pink;
              mix-blend-mode: multiply;
              z-index: 3;
            }
          }
          &-lower {
            height: 33%;
            @include flex-vertical-center;
            color: $ks-pink;
            &-bottom-left,
            &-bottom-right {
              position: absolute;
              bottom: 1rem;
              padding: 0;
              margin: 0;
            }
            &-bottom-left {
              left: 1rem;
            }
            &-bottom-right {
              right: 1rem;
            }
          }
        }
        &-bgslot {
          &-0,
          &-1,
          &-2 {
            background:  $ks-pink;
          }
          &-0 {
              transform: translate3d(0, -4rem, -60px);
              @include sm() {
                transform: translate3d(0, -2.5rem, -60px);
              }
              opacity: 0.8;
          }
          &-1 {
              transform: translate3d(0, -8rem, -120px);
              @include sm() {
                transform: translate3d(0, -5rem, -120px);
              }
              opacity: 0.6;
          }
          &-2 {
              transform: translate3d(0, -12rem, -180px);
              @include sm() {
                transform: translate3d(0, -7.5rem, -180px);
              }
              opacity: 0.4;
          }
        }
    }
    &-list {
      transform: translateZ(0px);
      * {
        transform: translateZ(0px);
      }
      max-width:  $wide-container;
      width: 100%;
      margin: auto;
      display: flex;
      flex-wrap: wrap;
      &-wrapper {
        background: white;
        padding: $nav-height 0;
        margin-top: -$nav-height;
        z-index: 29;
        @include sm() {
          padding: 0;
          margin-top: 0;
        }
        position: relative;
        @include vh(50, 'min-height');
      }
      &-card {
        width: 50%;
        padding-bottom: 33.333333333333333%;
        @include sm() {
          width: 100%;
          padding-bottom: 66.66666%;
        }
        position: relative;
        &-wrapper {
          @media (hover: hover) {
              transition: all 0.25s;
              &:hover {
                  transform: scale(1.02);
                  box-shadow: 3px 3px 7px 2px rgba(0,0,0,0.5);
              }
          }
          position: absolute;
          left: var(--pd1);
          right: var(--pd1);
          top: var(--pd1);
          bottom: var(--pd1);
          box-shadow: 0.25rem 0.25rem 0.5rem rgba(0,0,0,0.2);
          border-radius: var(--pd1);
          overflow: hidden;
        }
        &-upper {
          height: 50%;
          overflow: hidden;
          position: relative;
          img {
            width: 100%;
            height: 100%;
            position: absolute;
            left: 0px;
            top: 0px;
            object-fit: cover;
            filter: grayscale(100%);
          }
          &:after {
            content: "";
            position: absolute;
            left: 0px;
            top: 0px;
            width: 100%;
            height: 100%;
            background:  $ks-pink;
            mix-blend-mode: multiply;
            opacity: 1;
            z-index: 3;
          }
        }
        &-lower {
          bottom: 0px;
          height: 50%;
          width: 100%;
          position: absolute;
          @include flex-vertical-center;
          h2 {
            text-align: center;
            padding-bottom: var(--pd2);
          }
          background: $ks-grey;
          &-bottom-left,
          &-bottom-right {
            position: absolute;
            bottom: var(--pd15);
            padding: 0;
            margin: 0;
            @include smallfont();
          }
          &-bottom-left {
            left: var(--pd15);
          }
          &-bottom-right {
            right: var(--pd15);
          }
        }
        &-44 {
          .ks-projects-list-card-lower {
            background: $ks-light-blue;
          }
        }
      }
    }
    &-controller {
      
      //backdrop-filter: blur(10px);
      /*&-timemachine {
        background: transparent;
      }*/
      .ks-overlay-container-stickysubhead-wrapper {
        z-index: 100;
        @include closetaginsert($wide-container-margin);
        .ks-bullet-list {
          width: 37.5%;
          .ks-bullet-list-point {
            background: $ks-pink;
            border-color: $ks-pink;
          }
          &-active {
            .ks-bullet-list-point {
              background: white;
              border-color: $ks-pink;
            }
          }
        }
        .ks-round-button {
          background:  white;
          border-color: $ks-pink;
          span {
            color: $ks-pink;
          }
          &-active {
            span {
              color: white;
            }
            background: $ks-pink;
          }
        }
        .ks-slider {
          width: 50%;
          box-sizing: border-box;
          padding-left: var(--pd1);
  
          .vue-slider-dot-handle {
            background: white;
            border-color: $ks-pink;
            cursor: ew-resize;
          }
          .vue-slider-dot-tooltip-text {
            color: $ks-pink;
            cursor: ew-resize;
          }
          .vue-slider-rail {
            &:after {
              border-right-color: $ks-pink;
            }
            &:before {
              border-left-color: $ks-pink;
            }
          }
          .vue-slider {
            &:after {
              background: $ks-pink;
            }
          }
        }
        .ks-toggle {
          padding-left: 1rem;
          width: 12.5%;
          &-mode {
              .vue-toggles {
                width: 100% !important;
                background: white !important;
                border-color: $ks-pink !important;
                .dot {
                  background: $ks-pink !important;
                }
                &-active {
                  background: $ks-pink !important;
                  .dot {
                    background: white !important;
                  }
                }
              }
          }    
        }     
        @include sm() {
          .ks-slider {
            width: 75%;
          }
          .ks-bullet-list {
            width: 25%;
            margin-top: 4px;
            &-point {
              display: none;
            }
          }          
          .ks-toggle {
            display: none;
          }
        } 
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/Projects.vue